import { SyncManager } from 'db';
import { useForm } from 'react-final-form';
import { useFormVehicleId } from './useFormVehicleId';
import { base64ToObjectUrl } from 'utils';
import { getIn } from 'final-form';

export type SaveImagePayload = {
  file?: File | string | null;
  url?: string;
  url_thumb?: string;
  expiration_date?: string;
  is_damaged?: boolean;
  grade?: number;
  notes?: string;
};

export type SaveImageFn2 = (sectionId: string, imageIndex: number, payload: SaveImagePayload) => Promise<void>;

export const useUpdateImage2 = () => {
  const form = useForm();
  const vehicleId = useFormVehicleId();

  const save: SaveImageFn2 = async (sectionId, imageIndex, payload) => {
    if (!vehicleId || Object.keys(payload).length === 0) return;

    const values = form.getState().values;

    const section = getIn(values, sectionId);
    const sectionServerId = section?.id;
    const image = section?.images?.[imageIndex];
    const imageId = image?.id;
    const type = image?.type;

    const [, parsedType] = type?.split('.') || [];

    const sectionGradePath = `${sectionId}.subsections.${parsedType}.grade`;
    const localUrlPath = `${sectionId}.images.${imageIndex}.local_url`;
    const imageIdPath = `${sectionId}.images.${imageIndex}.id`;

    const syncManager = SyncManager.getInstance(vehicleId);

    const isNewImage = !imageId || imageId.toString() === `${sectionServerId}-${imageIndex}`;
    const entityType = isNewImage ? 'new_image' : 'image';
    const entityId = isNewImage ? `${sectionServerId}-${imageIndex}` : imageId;

    await syncManager.queueEntityUpdate(entityId, entityType, Object.entries(payload));

    if (isNewImage && !imageId) {
      form.change(imageIdPath, entityId);
    }

    if (payload.file && typeof payload.file === 'string') {
      form.change(localUrlPath, base64ToObjectUrl(payload.file));
    }

    if (payload.file && payload.file instanceof File) {
      form.change(localUrlPath, URL.createObjectURL(payload.file))
    }

    // auto-set section grade (tires) based on image grade
    if (sectionId.includes('tires') && payload.grade != null) {
      const score = payload.grade;
      const gradeValue = score <= 2 ? 'poor' : score === 3 ? 'fair' : 'good';
      form.change(sectionGradePath, gradeValue);
    }
  };

  return save;
};
